module.exports = __webpack_public_path__ + "img/2.70bb671c.png";